import getYear from "../../../../utils/getYear";
import config from "../../../../config/config";

const downloadSampleSize = (data) => {  
  const volume = data.volume === "chronic-kidney-disease" ? "CKD" : 
                        data.volume === "end-stage-renal-disease" ? "ESRD" :
                        data.volume === "end-stage-kidney-disease" ? "ESRD" :
                      "Supplements";
  const figurename = data.figureNumber.replace(/\s/g, "").replace(".", "").replace("/","");
  const url = `${config.baseUri}/SampleSize?year=${getYear()}&volume=${volume}&figurename=${figurename}`;
  window.location = url;
};

export default downloadSampleSize;
